module.exports = __webpack_public_path__ + "img/discord.387686cf.svg";